export default {
  "content": "<path d=\"M83.211.704H3.54a3 3 0 000 6h79.672a3 3 0 000-6z\" fill=\"#E9E9EB\"/>",
  "attrs": {
    "width": "87",
    "height": "7",
    "viewBox": "0 0 87 7",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};